import API from "..";
import { checkAPIAvailability } from "../helpers";

export default class SupplierTradename {
  /**
   * The Sample dimension table for M3
   * @param {String} supplierName The MIDAS of the Sample
   */
  constructor({
    id,
    supplierName,
    supplier,
    tradenameID,
    tradename,
    tradenameName,
    chemID,
    substanceName,
    lots,
  }) {
    this.id = id;
    this.supplierName = supplierName;
    this.supplier = supplier;
    this.tradenameID = tradenameID;
    this.tradename = tradename;
    this.tradenameName = tradenameName;
    this.chemID = chemID;
    this.substanceName = substanceName;
    this.lots = lots;
  }

  static async getAll(signal) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.get(`/suppliertradename`, signal ? { signal } : undefined);
    return (data?.result ?? []).map((d) => new SupplierTradename(d));
  }

  static async getByChemID(chemID) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.get(
      `/suppliertradename/byChemId?chemID=${encodeURIComponent(chemID)}`,
    );
    return (data?.result ?? []).map((d) => new SupplierTradename(d));
  }

  static async update(suppliertradename) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.put(`/suppliertradename`, suppliertradename);
    return data;
  }

  static async create(suppliertradename) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.post(`/suppliertradename`, suppliertradename);
    return data;
  }

  static async delete(id) {
    const api = await API();
    checkAPIAvailability(api);

    const { data } = await api.delete(`/suppliertradename/${id}`);
    return data;
  }
}
